import React from 'react';
import NewsListWithTitle from './NewsListWithTitle';
import s from '../styles/News.module.css';
import { cleanCourseName } from '@Util/util';

type NewsContent = {
    id: number;
    title: string;
    date: string;
};

type BlogProps = {
    staffBlogs: NewsContent[];
    courseName: string;
    courseId: string;
};

export const Blog = (props: BlogProps) => {
    return (
        <div className={s.blog_container}>
            <NewsListWithTitle
                title={`${cleanCourseName(props.courseName)}のスタッフブログ`}
                contents={props.staffBlogs}
                isStaffBlog={true}
                courseId={props.courseId}
            />
        </div>
    );
};

export default Blog;
